import React from 'react'
import styled from 'styled-components'
import { useParams, useNavigate } from 'react-router-dom'
import SharedBackLink from 'components/BackLink'
import ExtractedRemedialsReview from 'features/taskManagement/components/ExtractedRemedialsReview'

const RemedialsReviewPage = () => {
  const { bpId } = useParams()
  const navigate = useNavigate()

  const goBack = () => navigate(bpId ? `/bp-list/${bpId}/remedials` : '/actions')

  return (
    <Page>
      <BackBtn onClick={goBack}>Back to remedials</BackBtn>
      <ExtractedRemedialsReview bpId={bpId || null} pageMode />
    </Page>
  )
}

export default RemedialsReviewPage

const Page = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px 24px 64px;
`

const BackBtn = styled(SharedBackLink)`
  margin-bottom: 14px;
`
